import cn from 'classnames';

export const ModalContainer = ({ children, className }: { children: React.ReactNode, className?: string }) => {
  return (
    <div className={cn(className, "transition-all duration-200 ease-in-out relative z-[3000000001] bg-white rounded-10 overflow-hidden m-auto shadow-sm")}>
      {children}
    </div>
  );
};
